import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaChartLine, FaUsers, FaUserSlash, FaMoneyBill } from "react-icons/fa";

export default function Ejecutivos() {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [filtros, setFiltros] = useState({ nombre: "", rut: "", canal: "" });
  const [filtrando, setFiltrando] = useState(false);
  const [ejecutivos, setEjecutivos] = useState([]);

  const [modalCargaVisible, setModalCargaVisible] = useState(false);

  // ➕ Modal para ver listas (semana/mes)
  const [modalLista, setModalLista] = useState({ visible: false, title: "", items: [] });

  const [kpis, setKpis] = useState({
    totalVentas: 0,
    promedioPorEjecutivo: 0,
    ejecutivosActivos: 0,
    ejecutivosSinSemana: [],
    ejecutivosSinMes: [],
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      window.location.href = "/login";
      return;
    }
    cargarEjecutivos();
    cargarKPIs();
  }, []);

  const token = () => localStorage.getItem("token");

  const cargarEjecutivos = () => {
    setFiltrando(true);
    axios
      .get("https://api.t-sales.cl/api/ejecutivos", {
        params: filtros,
        headers: { Authorization: `Bearer ${token()}` },
      })
      .then((res) => setEjecutivos(res.data))
      .catch((err) => console.error("Error al cargar ejecutivos:", err))
      .finally(() => setFiltrando(false));
  };

  const cargarKPIs = () => {
    axios
      .get("https://api.t-sales.cl/api/ejecutivos/kpis", {
        headers: { Authorization: `Bearer ${token()}` },
      })
      .then((res) => setKpis(res.data))
      .catch((err) => console.error("Error al cargar KPIs:", err));
  };

  const handleChangeFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitFiltros = (e) => {
    e.preventDefault();
    cargarEjecutivos();
  };

  const handleResetFiltros = () => {
    setFiltros({ nombre: "", rut: "", canal: "" });
    cargarEjecutivos();
  };

  const handleExportar = () => {
    const query = new URLSearchParams({ ...filtros, export: 1 }).toString();
    window.open(`https://api.t-sales.cl/api/ejecutivos/export?${query}`, "_blank");
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  // Handlers para abrir el modal de listas
  const abrirModalLista = (title, items) => {
    setModalLista({ visible: true, title, items });
  };

  return (
    <div className="min-h-screen bg-[#006f91] text-white px-4 py-8 flex flex-col">
      <header className="max-w-6xl w-full mx-auto flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold">Listado de Ejecutivos</h1>
        <button
          onClick={handleLogout}
          className="bg-[#64FFDA] hover:bg-[#1DE9B6] text-[#0F1C17] font-semibold px-4 py-2 rounded-xl"
        >
          Cerrar sesión
        </button>
      </header>

      {/* KPIs */}
      <section className="max-w-6xl w-full mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <KpiCard icon={<FaMoneyBill />} label="Ventas Totales" value={kpis.totalVentas} />
        <KpiCard icon={<FaChartLine />} label="Promedio por Ejecutivo" value={Number(kpis.promedioPorEjecutivo).toFixed(2)} />
        <KpiCard icon={<FaUsers />} label="Ejecutivos Activos" value={kpis.ejecutivosActivos} />
        <KpiCard icon={<FaUserSlash />} label="Sin ventas esta semana" value={kpis.ejecutivosSinSemana.length} />
      </section>

      {/* Cuadro de advertencias (ahora muestra solo número + CTA para abrir modal) */}
      <section className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <WarningCard
          title="Ejecutivos sin ventas esta semana"
          items={kpis.ejecutivosSinSemana}
          onClick={() => abrirModalLista("Ejecutivos sin ventas esta semana", kpis.ejecutivosSinSemana)}
        />
        <WarningCard
          title="Ejecutivos sin ventas este mes"
          items={kpis.ejecutivosSinMes}
          onClick={() => abrirModalLista("Ejecutivos sin ventas este mes", kpis.ejecutivosSinMes)}
        />
      </section>

      {/* Filtros */}
      <section className="max-w-6xl w-full mx-auto bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/10 mb-6">
        <form onSubmit={handleSubmitFiltros} className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            type="text"
            name="nombre"
            placeholder="Buscar por nombre"
            value={filtros.nombre}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2"
          />
          <input
            type="text"
            name="rut"
            placeholder="Buscar por RUT"
            value={filtros.rut}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2"
          />
          <input
            type="text"
            name="canal"
            placeholder="Buscar por canal"
            value={filtros.canal}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2"
          />
          <div className="md:col-span-3 flex flex-wrap items-center justify-center gap-4 pt-2">
            <button type="submit" className="bg-[#64FFDA] text-[#0F1C17] px-4 py-2 rounded-xl font-semibold">
              Filtrar
            </button>
            <button type="button" onClick={handleResetFiltros} className="text-white/80 underline">
              Reiniciar filtros
            </button>
            <button type="button" onClick={handleExportar} className="bg-green-500 px-4 py-2 rounded-xl">
              📥 Exportar Excel
            </button>
            <button type="button" onClick={() => setModalCargaVisible(true)} className="bg-yellow-400 px-4 py-2 rounded-xl">
              📤 Cargar Ejecutivos
            </button>
          </div>
        </form>
      </section>

      {/* Tabla ejecutivos */}
      <section className="max-w-6xl w-full mx-auto flex-1 overflow-hidden">
        <div className="overflow-x-auto h-full bg-white/10 backdrop-blur-md rounded-xl border border-white/10">
          <table className="min-w-full text-sm text-left text-white">
            <thead className="text-xs uppercase text-white/90 bg-white/5 sticky top-0 z-10">
              <tr>
                {["Nombre", "RUT", "Correo", "Canal"].map((th) => (
                  <th key={th} className="px-4 py-3 font-semibold">{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrando ? (
                <tr><td colSpan={5} className="text-center py-10">Cargando datos...</td></tr>
              ) : ejecutivos.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-10">No se encontraron registros.</td></tr>
              ) : (
                ejecutivos.map((row) => (
                  <tr
                    key={row.id}
                    className="border-t border-white/10 hover:bg-white/5 cursor-pointer"
                    onClick={() => navigate(`/ejecutivos/${row.id}`)}
                  >
                    <td className="px-4 py-2">{row.nombre}</td>
                    <td className="px-4 py-2">{row.rut}</td>
                    <td className="px-4 py-2">{row.correo}</td>
                    <td className="px-4 py-2">{row.canal}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Modales */}
      <ModalCargarEjecutivos visible={modalCargaVisible} onClose={() => setModalCargaVisible(false)} />

      {/* ➕ Modal lista ejecutivos sin ventas */}
      <ModalLista
        visible={modalLista.visible}
        title={modalLista.title}
        items={modalLista.items}
        onClose={() => setModalLista((m) => ({ ...m, visible: false }))}
      />
    </div>
  );
}

/* ====== UI helpers ====== */
function KpiCard({ icon, label, value }) {
  return (
    <div className="bg-white/10 border border-white/10 rounded-xl p-4 flex flex-col items-center text-center shadow-md">
      <div className="text-3xl mb-2">{icon}</div>
      <div className="text-xl font-bold">{value}</div>
      <div className="text-sm text-white/80">{label}</div>
    </div>
  );
}

/** WarningCard: muestra solo el número y CTA para ver detalle en un modal */
function WarningCard({ title, items, onClick }) {
  const count = items?.length ?? 0;
  const hasNone = count === 0;

  return (
    <div
      className={`rounded-xl p-5 shadow-md border transition ${
        hasNone ? "bg-emerald-500/15 border-emerald-300/30" : "bg-white/10 border-white/10"
      }`}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold">{title}</h3>
        <span
          className={`text-xs px-2 py-1 rounded ${
            hasNone ? "bg-emerald-400/20 text-emerald-200" : "bg-white/20 text-white"
          }`}
        >
          {hasNone ? "OK" : "Atención"}
        </span>
      </div>

      <div className="mt-4 flex items-end justify-between">
        <div>
          <div className="text-4xl font-extrabold leading-none">{count}</div>
          <div className="text-sm text-white/80">ejecutivos sin ventas</div>
        </div>

        <button
          disabled={hasNone}
          onClick={onClick}
          className={`rounded-lg px-4 py-2 text-sm font-semibold transition ${
            hasNone
              ? "bg-white/10 text-white/50 cursor-not-allowed"
              : "bg-[#64FFDA] text-[#0F1C17] hover:bg-[#1DE9B6]"
          }`}
        >
          Ver detalle
        </button>
      </div>

      {hasNone && <p className="mt-3 text-white/80 text-sm">Todos han vendido 👏</p>}
    </div>
  );
}

/** Modal genérico para mostrar listas (semana/mes) */
function ModalLista({ visible, title, items, onClose }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-4"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white text-[#0F1C17] rounded-xl shadow-2xl w-full max-w-lg p-6 relative"
            initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >
            <button onClick={onClose} className="absolute top-3 right-3 text-gray-600 text-2xl">&times;</button>
            <h2 className="text-xl font-bold mb-1">{title}</h2>
            <p className="text-sm text-gray-500 mb-4">
              Total: <strong>{items?.length ?? 0}</strong>
            </p>

            {items && items.length > 0 ? (
              <div className="max-h-[50vh] overflow-auto rounded border border-gray-200">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left px-3 py-2 font-semibold">#</th>
                      <th className="text-left px-3 py-2 font-semibold">Ejecutivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((name, idx) => (
                      <tr key={`${name}-${idx}`} className="border-t">
                        <td className="px-3 py-2 w-12 text-gray-600">{idx + 1}</td>
                        <td className="px-3 py-2">{name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-sm text-gray-600">No hay ejecutivos en esta lista 🎉</div>
            )}

            <div className="mt-4 flex justify-end">
              <button onClick={onClose} className="px-4 py-2 rounded-lg bg-[#006f91] text-white">
                Cerrar
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

/** Modal existente: Cargar Ejecutivos (sin cambios funcionales) */
function ModalCargarEjecutivos({ visible, onClose }) {
  const [archivo, setArchivo] = useState(null);
  const [fechaUltimaCarga, setFechaUltimaCarga] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const token = () => localStorage.getItem("token");

  useEffect(() => {
    if (visible) {
      axios
        .get("https://api.t-sales.cl/api/ejecutivos/ultima-carga", {
          headers: { Authorization: `Bearer ${token()}` },
        })
        .then((res) => setFechaUltimaCarga(res.data.fecha))
        .catch(() => setFechaUltimaCarga("No disponible"));
    }
  }, [visible]);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!archivo) return alert("Selecciona un archivo .xlsx primero.");
    setSubiendo(true);
    const formData = new FormData();
    formData.append("archivo", archivo);

    axios
      .post("https://api.t-sales.cl/api/ejecutivos/cargar", formData, {
        headers: {
          Authorization: `Bearer ${token()}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => setMensaje("✅ Ejecutivos actualizados correctamente."))
      .catch(() => setMensaje("❌ Error al subir el archivo."))
      .finally(() => setSubiendo(false));
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-4"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white text-[#0F1C17] rounded-xl shadow-2xl w-full max-w-md p-6 relative"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >
            <button onClick={onClose} className="absolute top-3 right-3 text-gray-600 text-2xl">&times;</button>
            <h2 className="text-lg font-bold mb-4">📤 Cargar Ejecutivos</h2>

            <div className="space-y-3">
              <p><strong>Última carga de ejecutivos:</strong> {fechaUltimaCarga || "Cargando..."}</p>
              <input type="file" accept=".xlsx" onChange={handleFileChange} className="w-full" />
              {mensaje && <p className="text-sm mt-2">{mensaje}</p>}
              <button
                onClick={handleUpload}
                disabled={subiendo}
                className="bg-[#006f91] text-white px-4 py-2 rounded-xl w-full mt-3"
              >
                {subiendo ? "Subiendo..." : "Subir archivo"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
